<template>
  <div class="home">
    <!-- <HelloWorld/>1111 -->
    <!-- <demo1/> -->
  </div>
</template>

<script>
// @ is an alias to /src
// <!-- px-->rem -->
// import HelloWorld from '@/components/HelloWorld.vue'
// v-bind 的使用 绑定title
// import demo1 from '@/components/Demo/demo1.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld,
    // demo1
  }
}
</script>
